var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembershipIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.5443 13.9315L14.8842 19.9961C14.7113 20.1813 14.6152 20.4251 14.6152 20.6784V29.1592C14.6152 29.7115 15.0629 30.1592 15.6152 30.1592H28.4272C28.9795 30.1592 29.4272 29.7115 29.4272 29.1592V20.7442C29.4272 20.4523 29.2997 20.1749 29.078 19.9849L21.9261 13.8546C21.5193 13.5058 20.9099 13.5398 20.5443 13.9315Z",
    fill: "#FFAF24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26953 30.2166V17.1012C8.26953 16.2294 9.30726 15.7751 9.94783 16.3664L21.3175 26.8618C21.7119 27.2259 22.3234 27.2136 22.7029 26.8341L33.0124 16.5243C33.6423 15.8943 34.7195 16.3405 34.7195 17.2314V30.2166C34.7195 30.7689 34.2718 31.2166 33.7195 31.2166H9.26953C8.71725 31.2166 8.26953 30.7689 8.26953 30.2166Z",
    fill: "#FFAF24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipIcon);
export default __webpack_public_path__ + "static/media/membership-icon.ab72677dccb9938e53e515106782221a.svg";
export { ForwardRef as ReactComponent };